// Components==============
import { faAngleDown, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';
import './index.module.scss';
// =========================

const framerArrow = {
    open: {
        rotate: 180,
    },
    closed: {
        rotate: 0,
    },
};

const framerMenu = {
    open: {
        height: 'auto',

        transition: {
            delayChildren: 0.1,
            staggerChildren: 0.02,
        },
    },
    closed: {
        height: 0,
    },
};

const framerMenuItem = {
    open: {
        opacity: 1,
    },
    closed: {
        opacity: 0,
        transition: {
            duration: 0.1,
        },
    },
};

export default function SingleItemDropdown({
    text,
    options,
    selected,
    setSelected,
    purple,
}) {
    const [isDropped, setIsDropped] = useState(false);

    function handleClick(option) {
        setSelected(option);
        setIsDropped(false);
    }

    return (
        <motion.div
            initial="closed"
            animate={isDropped ? 'open' : 'closed'}
            styleName={`wrapper ${isDropped ? 'menuIsOpen' : ''} ${
                purple ? 'purple' : ''
            }`}
        >
            <div
                styleName="button"
                onClick={() => setIsDropped((prev) => !prev)}
            >
                <p>{selected || text}</p>
                <div styleName="buttons">
                    <button
                        type="button"
                        style={{ fontSize: 16 }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsDropped(false);
                            setSelected('');
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div styleName="divider" />
                    <motion.button
                        variants={framerArrow}
                        type="button"
                        style={{ fontSize: 24 }}
                    >
                        <FontAwesomeIcon icon={faAngleDown} />
                    </motion.button>
                </div>
            </div>
            <AnimatePresence>
                {isDropped && (
                    <motion.div
                        styleName="menu"
                        variants={framerMenu}
                        exit="closed"
                        initial="closed"
                        animate={isDropped ? 'open' : 'closed'}
                    >
                        <div styleName="padding">
                            {options.map((option) => {
                                const isSelected = selected === option;

                                return (
                                    <motion.div
                                        key={option}
                                        variants={framerMenuItem}
                                        styleName="menu-item"
                                        onClick={() => handleClick(option)}
                                    >
                                        <motion.p
                                            whileHover={{ x: 2 }}
                                            style={{
                                                fontWeight: isSelected
                                                    ? 600
                                                    : 400,
                                            }}
                                        >
                                            {option}
                                        </motion.p>
                                    </motion.div>
                                );
                            })}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
}
